// extracted by mini-css-extract-plugin
export var ImageFrameHover = "ImageFrameHover-module--ImageFrameHover--0ZDdu";
export var aniSpin = "ImageFrameHover-module--ani-spin--UvJwk";
export var bottom = "ImageFrameHover-module--bottom--hP9TK";
export var left = "ImageFrameHover-module--left--3SIo8";
export var right = "ImageFrameHover-module--right--NFkW3";
export var top = "ImageFrameHover-module--top--7EkUG";